export default __webpack_public_path__ + "static/bed_b.aa9f8a91505ad832fcaaebaf6a7de30f.svg";